"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSchoolSelectionView = void 0;
var _react = require("react");
var _useAdminApi = require("../hooks/useAdminApi");
var _main = require("../../../main");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _EnvironmentManager2 = _interopRequireDefault(require("../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SliderSchoolSelectionView = props => {
  const {
    getSchoolsAndSettlements
  } = (0, _useAdminApi.useAdminApi)();
  const {
    getLabel,
    setSliderView,
    setEnvironmentSchoolId
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const styles = (0, _EnvironmentManager2.default)();
  const defaultTabId = 'bySign';
  const [selectedTab, setSelectedTab] = (0, _react.useState)(defaultTabId);
  const [schoolsAndSettlements, setSchoolsAndSettlements] = (0, _react.useState)([]);
  const [selectedCityOption, setSelectedCityOption] = (0, _react.useState)();
  const [selectedSchoolOption, setSelectedSchoolOption] = (0, _react.useState)();
  const schoolSignInputRef = (0, _react.useRef)(null);
  const selectedSchool = (0, _react.useRef)();
  const tabs = (0, _react.useMemo)(() => [{
    id: 'bySign',
    label: getLabel('schoolBySign')
  }, {
    id: 'byName',
    label: getLabel('schoolByName')
  }], [getLabel]);
  const citiesOptions = (0, _react.useMemo)(() => schoolsAndSettlements.map(city => {
    return {
      value: city.cityId,
      label: city.cityName
    };
  }) || [], [schoolsAndSettlements]);
  const citySchoolsOptions = (0, _react.useMemo)(() => selectedCityOption?.value ? schoolsAndSettlements.find(c => c.cityId === selectedCityOption?.value)?.schools?.map(citySchool => {
    return {
      value: citySchool.schoolId,
      label: citySchool.schoolName
    };
  }) ?? [] : [], [schoolsAndSettlements, selectedCityOption?.value]);
  const onSchoolSignChange = schoolSign => {
    if (schoolSign && schoolsAndSettlements.length > 0) {
      schoolsAndSettlements.forEach(citySchools => {
        const citySchool = citySchools.schools.find(cs => cs.schoolSign === schoolSign);
        if (citySchool?.schoolId) {
          setSelectedCityOption({
            label: citySchools.cityName,
            value: citySchools.cityId
          });
          setSelectedSchoolOption({
            label: citySchool.schoolName,
            value: citySchool.schoolId
          });
        }
      });
    }
  };
  (0, _react.useEffect)(() => {
    const fetchAdminData = async () => {
      setSchoolsAndSettlements(await getSchoolsAndSettlements());
    };
    fetchAdminData();
  }, [getSchoolsAndSettlements]);
  (0, _react.useEffect)(() => {
    if (selectedSchoolOption?.value) {
      selectedSchool.current = schoolsAndSettlements.find(c => c.cityId === selectedCityOption?.value)?.schools?.find(s => s.schoolId === selectedSchoolOption?.value);
    } else {
      selectedSchool.current = undefined;
    }
    if (selectedTab === defaultTabId && schoolSignInputRef.current) {
      schoolSignInputRef.current.value = selectedSchool.current?.schoolSign ?? '';
    }
  }, [schoolsAndSettlements, selectedTab, selectedCityOption, selectedSchoolOption]);
  const onClose = () => {
    props?.onClose?.();
  };
  const onConfirm = () => {
    if (selectedSchool.current?.groupId) {
      setEnvironmentSchoolId(selectedSchool.current.groupId);
      setSliderView('main');
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "schoolSelectionView",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Header, {
      title: getLabel('schoolSelectionViewTitle')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-EnvironmentManager_Row'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Tabs, {
          defaultTabId: defaultTabId,
          tabs: tabs,
          id: 'schoolSelectionMethod',
          onTabClick: tab => {
            setSelectedTab(tab.id);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '1rem',
            alignItems: 'center',
            marginTop: '1.5rem'
          },
          children: [selectedTab === 'bySign' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Input, {
              id: "schoolSign",
              ref: schoolSignInputRef,
              type: "text",
              view: "none",
              onChange: value => {
                onSchoolSignChange(value);
              },
              borderRadius: {
                borderRadius: 10
              },
              placeholder: getLabel('schoolSignPlaceholder')
            }), selectedSchoolOption?.label && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: [selectedCityOption?.label, " / ", selectedSchoolOption?.label]
            })]
          }), selectedTab === 'byName' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: getLabel('settlement')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Select, {
              id: "schoolSettlement",
              isWithFilter: true,
              value: selectedCityOption,
              btnLabel: selectedCityOption ? '' : getLabel('select'),
              filterPlaceholder: getLabel('search'),
              onChange: option => {
                setSelectedCityOption(option);
                setSelectedSchoolOption(undefined);
              },
              btnProps: {
                color: 'basic',
                view: 'outlined'
              },
              options: citiesOptions
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: getLabel('school')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Select, {
              id: "schoolName",
              isWithFilter: true,
              value: selectedSchoolOption,
              btnLabel: selectedSchoolOption ? '' : getLabel('select'),
              filterPlaceholder: getLabel('search'),
              onChange: option => {
                setSelectedSchoolOption(option);
              },
              btnProps: {
                isDisabled: !selectedCityOption,
                color: 'basic',
                view: 'outlined'
              },
              options: citySchoolsOptions
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          view: "link",
          onClick: onClose,
          id: "backButton",
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          view: "contained",
          isDisabled: !Boolean(selectedSchoolOption?.value),
          onClick: onConfirm,
          id: "confirmButton",
          children: getLabel('confirm')
        })
      })]
    })]
  });
};
exports.SliderSchoolSelectionView = SliderSchoolSelectionView;